
const digest = '09ed1eaf2a769bb3370d03ba2991e1b315306c22cfea6c8bb319422bc735e69e';
const classes = {"wrapper":"_wrapper_avw7f_1","active":"_active_avw7f_10","icon":"_icon_avw7f_10","title":"_title_avw7f_14"};
const css = `._wrapper_avw7f_1 {
  font-family: Rubik, sans-serif;
  display: inline-block;
  cursor: pointer;
}
._wrapper_avw7f_1:hover {
  transform: scale(1.025);
}

._active_avw7f_10 ._icon_avw7f_10 {
  background: url("/dist/icons/react/folder-open-solid.svg") no-repeat center;
  background-size: contain;
}
._active_avw7f_10 ._title_avw7f_14 {
  color: #1d65d8;
}

._icon_avw7f_10 {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  background: url("/dist/icons/react/folder-solid.svg") no-repeat center;
  background-size: contain;
}

._title_avw7f_14 {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  